import { useRuntimeConfig } from '@xing-com/crate-xinglet/internal';
import { useExperiment } from '@xing-com/hub';

import {
  GOOGLE_ONE_TAP_EXPERIMENT,
  isGoogleOneTapEligible,
} from './eligibility';
import { useGoogleOneTap } from './use-google-one-tap';

const GOOGLE_ONE_TAP_CREDENTIAL_PATH = '/signup/oauth/credential';
const DEVELOPMENT_GOOGLE_ONE_TAP_CLIENT_ID =
  '404114861437-uoukh47dv9oepejqs96meobv55dt5rkd.apps.googleusercontent.com';
const PRODUCTION_GOOGLE_ONE_TAP_CLIENT_ID =
  '1086247973690-i8ljrag127q2dqum3fs0n1cspqs4un7b.apps.googleusercontent.com';

const usesProductionGoogleClient = (hostname: string | undefined): boolean => {
  return hostname === 'preview.xing.com' || hostname === 'www.xing.com';
};

export const getGoogleOneTapClientId = (
  hostname = typeof window === 'undefined'
    ? undefined
    : window.location.hostname
): string => {
  return usesProductionGoogleClient(hostname)
    ? PRODUCTION_GOOGLE_ONE_TAP_CLIENT_ID
    : DEVELOPMENT_GOOGLE_ONE_TAP_CLIENT_ID;
};

type GoogleOneTapProps = {
  isLoggedOut: boolean;
  trackPromptRequested: () => void;
};

export const GoogleOneTap: React.FC<GoogleOneTapProps> = ({
  isLoggedOut,
  trackPromptRequested,
}) => {
  const { isWebview } = useRuntimeConfig();
  const experimentVariant = useExperiment(GOOGLE_ONE_TAP_EXPERIMENT);
  const clientId = getGoogleOneTapClientId();
  const enabled = isGoogleOneTapEligible({
    clientId,
    experimentVariant,
    isLoggedOut,
    isWebview,
  });

  useGoogleOneTap({
    enabled,
    trackPromptRequested,
  });

  if (!enabled || !clientId) return null;

  return (
    <div
      id="g_id_onload"
      data-client_id={clientId}
      data-auto_select="false"
      data-login_uri={new URL(
        GOOGLE_ONE_TAP_CREDENTIAL_PATH,
        window.location.origin
      ).toString()}
    />
  );
};
